<template>
  <tr :class="{ hidden: !expanded }">
    <td colspan="7" class="p-0">
      <table class="mt-[-0px] mb-[-0px]">
        <tbody>
          <tr
            v-for="group in inspectionPointDevices"
            :key="group.floor ?? 'unknown'"
            class="bg-light-3 dark:bg-dark-4"
          >
            <td class="w-[10%] align-middle whitespace-nowrap px-3 py-2">
              {{ group.floor ?? '-' }}
            </td>

            <td colspan="2" class="w-[90%] align-middle px-3 py-2">
              <div class="flex flex-wrap gap-2">
                <BaseChip
                  v-for="entry in group.entries"
                  :key="`${entry.deviceId}-${entry.number}`"
                  :number="entry.number"
                  :text="entry.doorbellName"
                  :icon-end="entry.statusIcon"
                  :icon-color="entry.statusType"
                  data-testid="deviceRadioCheckResult"
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </td>
  </tr>
</template>

<script setup lang="ts">
import BaseChip from '@/components/UI/Chip/BaseChip.vue';
import { DeviceInfo } from '@/composables/useInstallationLocationsTable';

const props = defineProps<{
  inspectionPointDevices: DeviceInfo[];
  expanded?: boolean;
}>();
</script>
